import React, { type PropsWithChildren } from 'react';
import { Box, xcss, type BoxProps } from '@atlaskit/primitives';

export type CommentCardAppearance = 'default' | 'internal' | 'legacy';

type SupportedBoxProps = Pick<
	BoxProps<'div'>,
	| 'padding'
	| 'paddingBlock'
	| 'paddingBlockEnd'
	| 'paddingBlockStart'
	| 'paddingInline'
	| 'paddingInlineEnd'
	| 'paddingInlineStart'
>;
export type CommentCardProps = SupportedBoxProps & {
	appearance?: CommentCardAppearance;
	isFocused?: boolean;
	padding?: BoxProps<'div'>['padding'] | undefined;
	paddingBlock?: BoxProps<'div'>['paddingBlock'] | undefined;
	paddingBlockEnd?: BoxProps<'div'>['paddingBlockEnd'] | undefined;
	paddingBlockStart?: BoxProps<'div'>['paddingBlockStart'] | undefined;
	paddingInline?: BoxProps<'div'>['paddingInline'] | undefined;
	paddingInlineEnd?: BoxProps<'div'>['paddingInlineEnd'] | undefined;
	paddingInlineStart?: BoxProps<'div'>['paddingInlineStart'] | undefined;
};

const Card = ({
	children,
	isFocused,
	padding = 'space.150',
	paddingBlock,
	paddingBlockEnd,
	paddingBlockStart,
	paddingInline,
	paddingInlineEnd,
	paddingInlineStart,
	appearance = 'default',
}: PropsWithChildren<CommentCardProps>) => (
	<Box
		padding={padding}
		paddingBlock={paddingBlock}
		paddingBlockEnd={paddingBlockEnd}
		paddingBlockStart={paddingBlockStart}
		paddingInline={paddingInline}
		paddingInlineEnd={paddingInlineEnd}
		paddingInlineStart={paddingInlineStart}
		xcss={[
			appearance === 'internal' ? internalCardStyles : defaultCardStyles,
			isFocused && appearance === 'internal' && internalFocusCardStyles,
			isFocused && appearance === 'legacy' && legacyFocusCardStyles,
			isFocused && appearance === 'default' && defaultFocusCardStyles,
		]}
	>
		{children}
	</Box>
);

const legacyFocusCardStyles = xcss({
	backgroundColor: 'color.background.neutral',
});

const defaultCardStyles = xcss({
	transition: 'background-color 2s',
});
const defaultFocusCardStyles = xcss({
	backgroundColor: 'color.background.selected',
});

const internalCardStyles = xcss({
	backgroundColor: 'color.background.accent.yellow.subtlest',
});
const internalFocusCardStyles = xcss({
	backgroundColor: 'color.background.accent.yellow.subtle',
});

export default Card;
